import _ from 'lodash';

export const getErrors = (errors) => {
  const validationMessages = _.get(errors, 'data.validation_messages') || {};
  const result = {};

  _.forOwn(validationMessages, (value, key) => {
    if (key === 'indirizzi') {
      _.forOwn(value, (msg, subKey) => {
        result[subKey] = msg;
      });
    } else if (_.isObject(value)) {
      result[key] = _.values(value)[0];
    } else {
      result[key] = value;
    }
  });
  return result;
};

export default getErrors;



// WEBPACK FOOTER //
// ./app/shared/lib/geterrors/index.js